import React from "react";
import { Typography } from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";
import "./ToggleSwitch.css";

interface ToggleSwitchProps {
  isExpanded: boolean;
  onToggle: () => void;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  isExpanded,
  onToggle,
}) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex align-items-center">
      <div className="toggle-switch" onClick={onToggle}>
        <input type="checkbox" checked={isExpanded} readOnly />
        <span className="toggle-slider" />
        <span className={`toggle-button ${isExpanded ? "expanded" : ""}`}>
          <span
            className={`toggle-indicator ${isExpanded ? "expanded" : ""}`}
          />
        </span>
      </div>
      <div className="toggle-label">
        <Typography component="span" variant="mediumBold">
          {t("enrollmentStep.LoadManuallySignedDocument")}
        </Typography>
      </div>
    </div>
  );
};
